import React, { CSSProperties } from 'react';
import { useTranslation } from "react-i18next";

const baseStateStyling: CSSProperties =
{
    backgroundColor: "lightgrey",
    borderRadius: 10,
    border:"1px solid",
    padding: "0.3125rem 0.625rem",
    boxSizing: "border-box",
    whiteSpace: "nowrap",
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "1rem",
    lineHeight: "1.375rem",
    color: "#212121"
}


export default function TimeStatus(props: { timeDelta: number }) {
    const { t } = useTranslation();

    const minutes = Math.floor(props.timeDelta / (60 * 1000));
    if (minutes < 5) {
        return <span style={{ ...baseStateStyling, backgroundColor: "#edfcf2", borderColor: "#56db82" }} >{minutes} {minutes === 1 ? t("time.min") : t("time.mins")}</span>
    }
    else if (minutes < 10) {
        return <span style={{ ...baseStateStyling, backgroundColor: "#e8d7ba", borderColor: "#dba656" }} >{minutes} mins</span>
    }
    else if (minutes < 60) {
        return <span style={{ ...baseStateStyling, backgroundColor: "#e8baba", borderColor: "#f21136" }} >{minutes} mins</span>
    }
    else if (minutes < 60 * 24) {
        const hours = Math.floor(minutes / 60);
        return <span style={{ ...baseStateStyling, backgroundColor: "#e8baba", borderColor: "#f21136" }} >{hours} {hours === 1 ? t("time.hour") : t("time.hours")}</span>
    }
    else if (minutes < 60 * 24 * 30) {
        const days = Math.floor(minutes / (60 * 24));
        return <span style={{ ...baseStateStyling, backgroundColor: "#e8baba", borderColor: "#f21136" }} >{days} {days === 1 ? t("time.day") : t("time.days")}</span>
    }
    else if (minutes < 60 * 24 * 365) {
        const months = Math.floor(minutes / (60 * 24 * 30));
        return <span style={{ ...baseStateStyling, backgroundColor: "#e8baba", borderColor: "#f21136" }} >{months} {months === 1 ? t("time.month") : t("time.months")}</span>
    }
    else {
        const years = Math.floor(minutes / (60 * 24 * 365));
        return <span style={{ ...baseStateStyling, backgroundColor: "#e8baba", borderColor: "#f21136" }} >{years} {years === 1 ? t("time.year") : t("time.years")}</span>
    }
}